import * as uuid from 'uuid';

export type UUID = string & { __UUIDBrand: true };
/** NOTE: The UUID must not contain hyphens. */
export type OrderedUUID = string & { __OrderedUUIDBrand: true };

const generateUuid = (): UUID => {
  return uuid.v1() as UUID;
};

export const generateOrderedUUID = (): OrderedUUID => {
  const unordered = generateUuid();
  // Rearrange parts of the v1 UUID so that the values are chronologically ordered. Taken from https://github.com/peterkingsbury/ordered-uuid
  return (unordered.substr(14, 4) +
    unordered.substr(9, 4) +
    unordered.substr(0, 8) +
    unordered.substr(19, 4) +
    unordered.substr(24, unordered.length)) as OrderedUUID;
};

/** Client ID as an easily indexable string for frontend use. Should not contain hyphens. */
export type ClientId = string & { __clientIdBrand: true };

const uuidToClientId = (uuid: OrderedUUID): ClientId =>
  uuid.replace(/-/g, '') as unknown as ClientId;

export const generateClientId = (): ClientId => {
  return uuidToClientId(generateOrderedUUID());
};

/** Should be used to parse clientId's from the API into clientId's in our local structures.
 *
 */
export const parseClientId = (clientId: string): ClientId => {
  return clientId.replace(/-/g, '') as ClientId;
};

export const parseClientIdOpt = (
  clientId: string | null | undefined,
): ClientId | null => {
  return typeof clientId === 'string' ? parseClientId(clientId) : null;
};

export function isClientId(id: string | number | null): id is string {
  return typeof id === 'string';
}
